import React, { Component } from 'react';

export default class Leaderboard extends Component {
    constructor(props) {
        super(props);

        this.state = { leaderboardData: null };
        this.leaderboardLoadStatus = "idle";
    }

    loadLeaderboardData() {
        if (this.leaderboardLoadStatus == "loading") {
            // Let load
        } else {
            this.leaderboardLoadStatus = "loading";
            this.props.loader((leaderboard) => {
                if (this.leaderboardLoadStatus == "loading") {
                    this.setState({ leaderboardData: leaderboard });
                    this.leaderboardLoadStatus = "idle";
                }
            })
        }
    }

    componentWillUnmount() {
        this.leaderboardLoadStatus = "unmounted";
    }

    render() {
        let data = this.state.leaderboardData;
        if (!data) {
            setTimeout(() => this.loadLeaderboardData(), 100);
        }

        var elms = [];

        if (data) {
            var last_index = -1;
            for (var i = 0; i < data.length; i += 1) {
                let dat = data[i];
                let name = dat.name || <i>Anonymous</i>;
                
                if (last_index != (dat.index - 1)) {
                    // discontinuity
                    elms.push(<div key={i + "_d"} className="discontinuity">
                        <i className="fas fa-ellipsis-h"></i>
                    </div>);
                }
                last_index = dat.index;
    
                elms.push(<div key={i} className={"entry" + (dat.is_me ? " me" : "")}>
                    <div className="rank">{dat.rank}.</div>
                    <div className="name">{name}</div>
                    <div className="points">{dat.points} points</div>
                </div>);
            }
        }

        return <div className="leaderboard">
            <div className="inner">
                <div className="header">
                    <h3>Worldwide Leaderboard</h3>
                    <div className="close" onClick={this.props.onClose}>Close</div>
                </div>

                <div className="entries">
                    {elms}
                </div>

                <p>You receive one point for each answer you get correct. Keep playing to help us collect more data and get more points.</p>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/Leaderboard.js